module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-corrente-strass-0a33d6ee91afc36a358392de9affa27d.jpg";